export default {
    Engine: {
        id: 0,
        label: 'ENGINE'
    },
    Discovery: {
        id: 1,
        label: 'DISCOVERY'
    },
    Device: {
        id: 2,
        label: 'DEVICE'
    },
    Account: {
        id: 3,
        label: 'ACCOUNT'
    },
    Maintenance: {
        id: 4,
        label: 'MAINTENANCE'
    }
};
